import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';

import Alert from '../common/Alert';
import Loader from '../common/Loader';

import { sanitizeUrl } from '../../utils/sanitizeUrl';
import useQuery from '../../utils/useQuery';

import { http } from '../../utils/http';

const VerifyEmailForm = () => {
  const query = useQuery();
  const appURL = sanitizeUrl(query['app_url']);
  const { token } = query;

  const [isLoading, setLoading] = useState(true);

  const [error, setError] = useState();

  useEffect(() => {
    http('/v1/account/verify-email', 'POST', { hash: token })
      .then((res) => {
        if (res.message && res.code === 16) {
          setError(res.message);
          setLoading(false);
        } else {
          setLoading(false);
          setTimeout(() => { window.location.href = '/profile'; }, 10000);
        }
      });
  }, []);

  const intl = useIntl();

  return (
    <>
      { isLoading
        ? (<Loader size={100} colored />)
        : error
          ? (
            <Alert
              title={intl.formatMessage({
                id: 'sendEmailVerification.title.error',
                defaultMessage: 'Something went wrong!',
                description: 'Title of the page, in case sending a verification email failed. Is followed by a error description'
              })}
              description={error}
              icon="error"
            />
          )
          : (
            <Alert
              title={intl.formatMessage({
                id: 'verifyEmail.title.success',
                defaultMessage: 'Your email confirmed!',
                description: 'Title of the page, in case email verification succeeded'
              })}
              actionTitle={
                appURL
                  ? intl.formatMessage({
                    id: 'verifyEmail.text.toApp',
                    defaultMessage: 'Go to app',
                    description: 'Main CTA, leading user back to the app'
                  })
                  : intl.formatMessage({
                    id: 'verifyEmail.text.toAccount',
                    defaultMessage: 'Open my cabinet',
                    description: 'Main CTA, leading user back to main profile page'
                  })
              }
              href={appURL || '/profile'}
              icon="success"
            />
          )}
    </>
  );
};

export default VerifyEmailForm;
